import api from './api'

export default {
  currentMonth() {
    return api.get('/filiation/video-watchs/current-month')
  },

  period(params) {
    return api.get(`/filiation/video-watchs/period`, { params })
  },
}
